import createRegl, {} from 'regl';
export function createReglContext(canvas) {
    const regl = createRegl({
        canvas: canvas,
        attributes: {
            premultipliedAlpha: true,
            antialias: true,
            preserveDrawingBuffer: true,
        },
        extensions: ['OES_standard_derivatives'],
    });
    const ctx = {
        regl,
        sizePx: {
            width: canvas.width,
            height: canvas.height,
        },
        resizeToCss(widthCss, heightCss, dpr) {
            const c = canvas;
            const w = Math.max(1, Math.round(widthCss * dpr));
            const h = Math.max(1, Math.round(heightCss * dpr));
            if (c.width !== w)
                c.width = w;
            if (c.height !== h)
                c.height = h;
            ctx.sizePx = { width: w, height: h };
            // regl caches the GL viewport at initialization and from its own poll
            // loop; explicitly poll so the next draw covers the new framebuffer.
            regl.poll();
        },
        destroy() {
            regl.destroy();
        },
    };
    return ctx;
}
//# sourceMappingURL=setup.js.map